module.exports = __webpack_public_path__ + "img/components-grid.84906891.png";